module.exports = __webpack_public_path__ + "media/images/star-3-07449e48267af63b8f31e0e5a400fed9.png";